import React, { useState } from "react";
import { FaTwitter, FaLinkedin, FaDiscord, FaYoutube, FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";


const MouseFooter = ({ handleScroll }) => {
  const [footerPos, setFooterPos] = useState({ x: 50, y: 50 });

  const handleFooterMouse = (e) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const relX = ((e.clientX - left) / width - 0.5) * 15;
    const relY = ((e.clientY - top) / height - 0.5) * 15;
    setFooterPos({ x: 50 + relX, y: 50 + relY });
  };

  return (
    <footer
      className="footer"
      onMouseMove={handleFooterMouse}
      onMouseLeave={() => setFooterPos({ x: 50, y: 50 })}
    >
      {/* Background splash only */}
      <div
        className="footer-splash"
        style={{
          background: `
            radial-gradient(
              400px circle at ${footerPos.x}% ${footerPos.y}%,
              rgba(0, 180, 150, 0.25),
              transparent 70%
            ),
            radial-gradient(
              300px circle at ${footerPos.x + 20}% ${footerPos.y - 10}%,
              rgba(50, 100, 200, 0.2),
              transparent 80%
            ),
            radial-gradient(
              500px circle at ${footerPos.x - 15}% ${footerPos.y + 20}%,
              rgba(0, 255, 200, 0.1),
              transparent 85%
            )
          `,
          filter: "blur(60px)",
          transition: "background 0.3s ease-out",
        }}
      ></div>

      {/* Foreground content */}
      <div className="footer-container">
        {/* 🌐 Navigation */}
        <div className="footer-nav">
          <h4>Explore</h4>
          <ul>
            <li>
              <a
                href="#about"
                onClick={(e) => handleScroll && handleScroll(e, "about")}
              >
                About
              </a>
            </li>
            <li>
              <ul className="submenu">
                <li>
                  <a
                    href="/whitepaper.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                  >
                    Whitepaper
                  </a>
                </li>
                <li>
                <Link
                  to="/download"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                  Download Ego Desktop
                </Link>
                </li>
                <li>
                <Link
                  to="/blog"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                  Blog
                </Link>
                </li>
                <li>
                <Link
                  to="/docs"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                  Docs
                </Link>
                </li>
                <li>
                <Link
                  to="/egoscan"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                  EgoScan
                </Link>
                </li>
                <li>
                <Link
                  to="/claim"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                  Claim EGOC
                </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        {/* 👥 Community */}
        <div className="footer-community">
          <h4>Community</h4>
          <ul>
            <li>
              <a href="#waitlist">Join Newsletter</a>
            </li>
            <li>
              <a href="https://discord.gg/FKAbxM4Enf" target="_blank" rel="noopener noreferrer">
                Discord
              </a>
            </li>
            <li>
              <a href="mailto:contact@egoblockchain.com">
                Partnerships / Join Us
              </a>
            </li>
          </ul>
        </div>

        {/* 🔗 Social Media */}
        <div className="footer-social">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a
              href="https://x.com/ego_blockchain"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.linkedin.com/company/ego-blockchain"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://discord.gg/FKAbxM4Enf"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Discord"
            >
              <FaDiscord />
            </a>
            <a
              href="https://www.youtube.com/@egoblockchain"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
            <a
              href="https://github.com/ego-blockchain/ego-blockchain-"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <FaGithub />
            </a>
          </div>
        </div>
      </div>

      {/* ⚖️ Bottom Bar */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Ego Blockchain. All rights reserved.</p>
        <div className="footer-links">
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
            </a>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
            Terms & Conditions
            </a>
        </div>
        </div>

    </footer>
  );
};

export default MouseFooter;
